import { Button } from "react-bootstrap";
import { ReactComponent as Bubble } from "../../../assets/Icons/message-circle.svg";
import styles from "./QuickHelpButton.module.scss";
import { useState, useEffect } from "react";
import ChatSupportFormModal from "components/organisms/ChatSupportFormModal/ChatSupportFormModal";

export const QUICK_HELP_OPEN_EVENT = "alivia:openQuickHelp";

export default function QuickHelpButton({ isUserLoggedIn }: { isUserLoggedIn?: boolean }) {
  // TODO: do zastapienia pozniej
  // const openHelpMessage = useOpenHelpMessage();

  const [isChatSupportFormModalVisible, setIsChatSupportFormModalVisible] =
    useState<boolean>(false);

  const handleShowingChatSupportFormModal = () => {
    setIsChatSupportFormModalVisible(true);
  };

  // Nasłuchiwanie na event z zewnętrznego kodu (np. osadzonego HTML w Landing)
  useEffect(() => {
    const handleExternalOpen = () => {
      setIsChatSupportFormModalVisible(true);
    };

    window.addEventListener(QUICK_HELP_OPEN_EVENT, handleExternalOpen);
    return () => {
      window.removeEventListener(QUICK_HELP_OPEN_EVENT, handleExternalOpen);
    };
  }, []);

  return (
    <>
      <Button
        onClick={handleShowingChatSupportFormModal}
        className={`${styles.button} ${styles.active}`}
      >
        <Bubble />
        NAPISZ DO NAS
      </Button>
      <ChatSupportFormModal
        show={isChatSupportFormModalVisible}
        onHide={() => setIsChatSupportFormModalVisible(false)}
        setShow={setIsChatSupportFormModalVisible}
        isUserLoggedIn={isUserLoggedIn}
      />
    </>
  );
}
